import { FC, useEffect, useState } from "react";
import { Button, Form, Input, Modal, Upload, Select, DatePicker } from "antd";
import { useForm, useModal } from "@refinedev/antd";
import {
  errorNotification,
  successNotification,
  safeDayjs,
} from "../../../helpers";
import type { RcFile, UploadFile } from "antd/es/upload/interface";
import axAPI from "../../../api/axios-instance";
import type { VideoType } from "./Video-List";
import { leagueOptions } from "../leagueOptions";

type VideoEditProps = {
  record: VideoType;
};

export const VideoEdit: FC<VideoEditProps> = ({ record }) => {
  const { modalProps, show, close } = useModal();
  const { formProps, form, formLoading } = useForm({
    action: "edit",
    resource: "video",
    id: record.id,
    dataProviderName: "videoDataProvider",
    redirect: false,
    ...successNotification({
      successData: { message: "Видео обновлено", type: "success" },
      callback: () => {
        close();
        setFileList([]);
      },
    }),
    ...errorNotification({}),
  });

  const [fileList, setFileList] = useState<UploadFile[]>([]);

  useEffect(() => {
    if (modalProps.open && formProps.initialValues) {
      const { img, date, ...rest } = formProps.initialValues as any;
      form.setFieldsValue({
        ...rest,
        img,
        date: safeDayjs(date),
      });
      if (img) {
        setFileList([
          {
            uid: "-1",
            name: "image",
            status: "done",
            url: img,
          },
        ]);
      } else {
        setFileList([]);
      }
    }
  }, [modalProps.open, formProps.initialValues]);

  const uploadImage = async (file: RcFile) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const { data } = await axAPI.post(
        "/cms/image/upload/type?type=MATCH",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setFileList([
        {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: data,
        },
      ]);
      form.setFieldValue("img", data);
    } catch (e) {
      // ignore
    }
  };

  const beforeUpload = async (file: RcFile) => {
    await uploadImage(file);
    return false;
  };

  const onAfterClose = () => {
    setFileList([]);
  };

  return (
    <>
      <Button onClick={show} size="small">
        Редактировать
      </Button>
      <Modal
        destroyOnClose
        afterClose={onAfterClose}
        title={"Редактирование видео"}
        onCancel={close}
        {...modalProps}
        footer={<></>}
      >
        <Form
          style={{ width: "100%", marginTop: 16 }}
          {...formProps}
          layout="vertical"
        >
          <Form.Item
            name="name"
            label="Название"
            rules={[{ required: true, message: "Укажите название" }]}
          >
            <Input placeholder="Укажите название" />
          </Form.Item>
          <Form.Item
            name="link"
            label="Ссылка"
            rules={[{ required: true, message: "Укажите ссылку" }]}
          >
            <Input placeholder="Укажите ссылку" />
          </Form.Item>
          <Form.Item
            name="leagueId"
            label="Лига"
            rules={[{ required: true, message: "Укажите лигу" }]}
          >
            <Select options={leagueOptions} placeholder="Выберите лигу" />
          </Form.Item>
          <Form.Item
            name="date"
            label="Дата публикации"
            rules={[{ required: true, message: "Укажите дату" }]}
          >
            <DatePicker
              showTime={{ format: "HH:mm" }}
              format="DD.MM.YYYY HH:mm"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item label="Превью">
            <Upload
              maxCount={1}
              listType="picture"
              beforeUpload={beforeUpload}
              fileList={fileList}
              onRemove={() => {
                setFileList([]);
                form.setFieldValue("img", undefined);
              }}
            >
              <Button>Выбрать файл</Button>
            </Upload>
          </Form.Item>
          <Form.Item name="img" hidden />
          <Button type="primary" htmlType="submit" loading={formLoading}>
            Сохранить
          </Button>
        </Form>
      </Modal>
    </>
  );
};
